export default {
  namespaced: true,
  state: {
    auditStateEnum: [
      {label: '待审核', value: 1},
      {label: '已通过', value: 2},
      {label: '已拒绝', value: 3},
    ],
    saleStateEnum: [
      {label: '上线', value: 1},
      {label: '下线', value: 0},
    ],
    // creditChannelEnum: [
    //   {label: '线上', value: 1},
    //   {label: '线下', value: 2},
    // ],
    // creditTimeEnum: [
    //   {label: '3个月', value: 1},
    //   {label: '6个月', value: 2},
    //   {label: '1年', value: 3},
    // ],
    // guaranteeMethodEnum: [
    //   {label: '住房贷', value: 1},
    //   {label: '车贷', value: 2},
    //   {label: '信用贷', value: 3},
    // ],
    // creditAmountEnum: [
    //   {label: '5万', value: 1},
    //   {label: '10万', value: 2},
    //   {label: '20万', value: 3},
    // ],
    orderStateEnum: [
      {label: '申请中', value: 1},
      {label: '申请通过', value: 2},
      {label: '申请拒绝', value: 3},
      {label: '已完成', value: 4},
    ],
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/service/index.js